// extracted by mini-css-extract-plugin
module.exports = {"withoutControls":"MuxVideoPlayer_withoutControls__cnDm1","buttonContainer":"MuxVideoPlayer_buttonContainer__T4awX","button":"MuxVideoPlayer_button__82vOg"};